<template>
    <div class="qk_head EC_width">
        <div class="pub_left_logo">
            <img src="/image/qkxy/qkbiglogo.png">
        </div>
        <div class="pub_center_menu">
            <ul class="pub_menu">
                <li class="pub_menu_active"><a href="#">首页</a></li>
                <li><a href="#">全部课程</a></li>
                <li><a href="#">专家</a></li>
                <li><a href="#">机构</a></li>
                <li><a href="#">团课</a></li>
            </ul>
        </div>
        <div class="pub_right_opra">
            <div class="inputRelative">
                <input type="text" name="" id="" value="" class="pub_head_bar_search" />
                <img src="/image/qkxy/heifangdajing.png">
            </div>
            <img src="/image/qkxy/lvren.png" class="pub_mes_img">
            <span class="marginRight20">
						登录
					</span>
            <span>
						注册
					</span>
        </div>
    </div>
</template>

<script>
    export default {
        name: "head_index"
    }
</script>

<style scoped>
    .qk_head{
        height: 77px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .pub_left_logo {
        width: 420px;
    }

    .pub_center_menu {
        flex: 1;
        height: 100%;
    }

    .pub_menu {
        list-style: none;
        padding: 0;
        margin: 0;
        overflow: hidden;
        height: 100%;
    }

    .pub_menu li {
        float: left;
        height: 100%;
        line-height: 77px;
    }

    .pub_menu li a {
        padding: 0 20px;
    }

    .pub_menu_active a {
        color: #0B8686;
    }

    .pub_right_opra {
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .inputRelative {
        position: relative;
        display: inline-block;
    }

    .pub_head_bar_search {
        width: 200px;
        height: 24px;
        box-sizing: border-box;
        border-radius: 24px;
        outline: none;
        border: 1px solid #ddd;
        padding-left: 12px;
    }

    .inputRelative img {
        position: absolute;
        right: 11px;
        top: 3px;
        cursor: pointer;
    }

    .pub_mes_img {
        margin: 0 20px;
    }

    .pub_bar_headimg {
        display: inline-block;
        width: 24px;
        height: 24px;
        border-radius: 24px;
        overflow: hidden;
        line-height: 24px;
        text-align: center;
        border: 1px solid #ddd;

    }
</style>
